import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CancellationPolicyService {

  urlEndpoint = 'cancellationPolicy';

  constructor(
    private http: HttpClient
  ) { }

  evaluateForReservation(reservationId: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/${this.urlEndpoint}/reservation/${reservationId}`);
  }
}
